import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/**
 * The ".NET" wordmark - MUI ships no Microsoft brand glyph. Drawn as paths
 * rather than an SVG <text> element so it does not depend on the host font
 * stack, and in currentColor so it follows hover/selected states.
 */
export const DotNetIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <circle cx="3.2" cy="16.2" r="1.4" />
    <path d="M5.8 7H7.4l2.3 6.4V7h1.6v10H9.7L7.4 10.6V17H5.8Z" />
    <path d="M12.4 7h4v1.6H14v2.6h2.1v1.6H14v2.6h2.4V17h-4Z" />
    <path d="M17.4 7h4.8v1.6h-1.6V17H19V8.6h-1.6Z" />
  </SvgIcon>
);
